import { render, staticRenderFns } from "./PedidoCuentaRespuestaPage.vue?vue&type=template&id=fd3b48ba&scoped=true"
import script from "./PedidoCuentaRespuestaPage.vue?vue&type=script&lang=js"
export * from "./PedidoCuentaRespuestaPage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fd3b48ba",
  null
  
)

export default component.exports